export default function BondingLiquidTierComparison() {
  const tiers = [
    {
      name: "Everyday",
      subtitle: "General purpose bonding",
      description: "For standard plastering and screed applications",
      bgColor: "#F2C612",
      textColor: "text-black",
      features: [
        "Improves adhesion",
        "Reduces shrinkage",
        "Interior use",
        "Easy to apply",
        "Dilutable"
      ]
    },
    {
      name: "Contractor Grade",
      subtitle: "Enhanced bonding for demanding jobs",
      description: "Professional-grade performance for challenging applications",
      bgColor: "#2D7AC2",
      textColor: "text-white",
      features: [
        "Superior adhesion",
        "Interior and exterior",
        "Faster bonding",
        "Weather resistant",
        "Wide application range"
      ]
    },
    {
      name: "Elite Pro Series",
      subtitle: "Maximum bonding strength",
      description: "Ultimate performance for critical structural work",
      bgColor: "#D42B2B",
      textColor: "text-white",
      features: [
        "Extreme adhesion",
        "Structural applications",
        "Rapid setting",
        "Waterproof",
        "Commercial grade"
      ]
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <h2 className="text-4xl font-bold text-center mb-16 font-['Montserrat']">
          Choose Your Grade
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          {tiers.map((tier) => (
            <div
              key={tier.name}
              className="rounded-lg overflow-hidden shadow-lg"
              style={{ backgroundColor: tier.bgColor }}
            >
              <div className={`p-8 ${tier.textColor}`}>
                <h3 className="text-2xl font-bold mb-2 font-['Montserrat']">
                  {tier.name}
                </h3>
                <p className={`text-sm font-semibold mb-2 ${tier.textColor === 'text-white' ? 'opacity-90' : 'opacity-70'}`}>
                  {tier.subtitle}
                </p>
                <p className={`text-sm mb-6 ${tier.textColor === 'text-white' ? 'opacity-80' : 'opacity-60'}`}>
                  {tier.description}
                </p>

                <div className="space-y-3">
                  {tier.features.map((feature, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <i className={`ri-check-line text-xl ${tier.textColor} flex-shrink-0 mt-0.5`}></i>
                      <span className="text-sm leading-relaxed">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}